import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { IconLink } from '@tabler/icons-react';
import InfoUnavailable from '../../../../../components/common/InfoUnavailable';

function DrugInformation({ commercialDrugInfo, commercialPlanInfo, drugName }) {
  const refactoredInformation = commercialDrugInfo?.body;
  const drugFormularyUrl =
    commercialPlanInfo?.contact_and_links?.links?.drug_formulary_url?.trim();

  const formatDrugTier = (text) => {
    if (text === 'NULL') {
      return 'Not Specified';
    }
    return text
      .toLowerCase()
      .replace(/-/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <div
      className="tab-pane fade show active"
      id="pills-home1-commercial"
      role="tabpanel"
      aria-labelledby="pills-home-tab"
      tabIndex={0}
    >
      <div>
        <h1 className="drug-name">
          {drugName}
          <span className="px-2">Covered</span>
        </h1>
        {refactoredInformation ? (
          <div className="row">
            <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
              <label>Drug Tier</label>
              <p>
                {formatDrugTier(refactoredInformation?.plans[0]?.drug_tier)}
              </p>
            </div>
            <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
              <label>Step Therapy</label>
              <p>
                {refactoredInformation?.plans[0]?.step_therapy
                  ? 'Step Therapy Required'
                  : 'No Step Therapy Required'}
              </p>
            </div>
            <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
              <label>Prior Authorization</label>
              <p>
                {refactoredInformation?.plans[0].prior_authorization
                  ? 'Prior Authorization Required'
                  : 'No Prior Authorization Required'}
              </p>
            </div>
            <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
              <label>Quantity Limit</label>
              <p>
                {refactoredInformation?.plans[0]?.quantity_limit
                  ? 'Quantity Limit Applies'
                  : 'No Quantity Limit'}
              </p>
            </div>
            <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
              <label>Route</label>
              <p className="text-capitalize">
                {refactoredInformation?.rxcui_info?.Route}
              </p>
            </div>
            <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
              <label>Dosage Form</label>
              <p className="text-capitalize">
                {refactoredInformation?.rxcui_info?.DosageForm}
              </p>
            </div>
            <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
              <label>Unit</label>
              <p>{refactoredInformation?.rxcui_info?.Unit}</p>
            </div>
            <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
              <label>Classification (ETC)</label>
              <p>{refactoredInformation?.rxcui_info?.Classification}</p>
            </div>
            <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
              <label>Federal Legend</label>
              <p>{refactoredInformation?.rxcui_info?.FederalLegendCodeDesc}</p>
            </div>
            {/* <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
              <label>Years</label>
              <p>Applicable Year: {refactoredInformation?.plans[0]?.years}</p>
            </div> */}
            <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
              <label>Additional Resources</label>
              {drugFormularyUrl ? (
                <Link to={drugFormularyUrl} target="_blank">
                  <IconLink size={16}></IconLink>
                  View Formulary
                </Link>
              ) : (
                <div className="drugsearch-content">
                  <p>Formulary URL not available</p>
                </div>
              )}
            </div>
          </div>
        ) : (
          <InfoUnavailable />
        )}
      </div>
    </div>
  );
}

DrugInformation.propTypes = {
  commercialDrugInfo: PropTypes.object.isRequired,
  commercialPlanInfo: PropTypes.object.isRequired,
  drugName: PropTypes.string.isRequired,
};

export default DrugInformation;
